import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from "react-helmet";

import dashboardData from '../../data/dashboard_data.json';

import RankAndMagnitudeContainer from '../RankAndMagnitudeChart/RankAndMagnitudeChartContainer';
import TopNRankAndMagnitudeDashboardContainer from '../TopNRankAndMagnitudeDashboard/TopNRankAndMagnitudeDashboardContainer';

import NPSDashbaordContainer from '../NPSDashboard/NPSDashboardContainer';
import XDashbaordContainer from '../XDashboard/XDashboardContainer';
import MagnitudeDashboardContainer from '../MagnitudeDashboard/MagnitudeDashboardContainer';
import BackgroundDashboardContainer from '../BackgroundDashboard/BackgroundDashboardContainer';

import { ThemeContext } from '../../themeContext';

class Dashboard extends Component {

    static propTypes= {
        isLargeScreen: PropTypes.bool.isRequired,
        isMediumScreen: PropTypes.bool.isRequired,
        data: PropTypes.array.isRequired,

    }
    _getDashboardDetails(dashboardId) {
        if (!dashboardId) return;
    
        const dashboardDetail = dashboardData.find((dashboardDetail)=>{
            return dashboardDetail.name === dashboardId
        });
        
        return dashboardDetail
    }

    customTooltip(value, sentimentDistnTable, dimension, questions, sentiment, percentage) {
        const row = sentimentDistnTable.filter((row)=>{
                           return row.questionLabel === value
                       })[0]

       let category = '';
       if (dimension !== 'eduBg') {
           if (row.dimCategory && row.dimCategory !== 'None of these describe my role') {
               category = `who are ${row.dimCategory.toLowerCase()}s`; 
           } else if(row.dimCategory === 'None of these describe my role') {
               category = "whose roles cannot be described"
           }else {}
       } else {
           if (row.dimCategory && row.dimCategory !== 'Other') {
               category = `who hava a ${row.dimCategory.toLowerCase()}s background`; 
           } else if(row.dimCategory === 'None of these describe my role') {
               category = `who hava some ${row.dimCategory.toLowerCase()} background`
           }else {}
       }
       

       switch (row.questionValue) {
           case questions[0].value: 
                   return `${Math.abs(percentage)}% of the respondents ${category} ${sentiment} 
                           that they have adequate resources to explore the data visualization options they want to use.`
           case questions[1].value: 
                   return `${Math.abs(percentage)}% of the respondents  ${category} ${sentiment} that they
                           want to make better visualizations but don't have the time/energy/resources.`
           case questions[2].value: 
                   return `${Math.abs(percentage)}% of the respondents  ${category}  ${sentiment} that they are
                           always on the lookout for new data visualization tools and techniques 
                           that will make their workflows faster and more efficient
                           `
           case questions[3].value: 
           return `${Math.abs(percentage)}% of the respondents  ${category} ${sentiment} that their
                                   skills hold them back much more than my tools do.
                   `
           default:
               break;
       } 
   }

    render() {
        let dashboardId = null;
        let dashboardCategory = null;
        const theme = this.context.theme;
       // console.dir(theme);

        let containerStyle = {
            background: theme.background
        }
        if (this.props.match.params) {
            dashboardId = this.props.match.params.id;
            dashboardCategory = this.props.match.params.category
        }
    
        const detail = this._getDashboardDetails(dashboardId)
       // console.dir(detail)
        let selectedDashboard = null;
        if (dashboardCategory === 'ram') {
            let containerData = {
                dimensions: detail.dimensions,
                col: detail.variableOfInterest,
                data: this.props.data,
                isProportionValues: detail.isProportionValues,
                dimensionLabels: detail.dimensionLabels,
                isMediumScreen: this.props.isMediumScreen,
                isLargeScreen: this.props.isLargeScreen,
                dashboardTitle: detail.dashboardTitle,
                overallChartTitle:  detail.overallChartTitle,
                dimensionChartsTitle: detail.dimensionChartsTitle,
            }
            selectedDashboard = <RankAndMagnitudeContainer  {...containerData} />  
        } else if(dashboardCategory === 'nps') {
            let containerData = {
                dimensions: detail.dimensions,
                col: detail.variableOfInterest,
                data: this.props.data,
                dimensionLabels: detail.dimensionLabels,
                isMediumScreen: this.props.isMediumScreen,
                isLargeScreen: this.props.isLargeScreen,
                dashboardTitle: detail.dashboardTitle,
                overallChartTitle:  detail.overallChartTitle,
                dimensionChartsTitle: detail.dimensionChartsTitle,
                questions: detail.questions,
                customTooltip: this.customTooltip
            }
            selectedDashboard = <NPSDashbaordContainer  {...containerData} />  

        } else if (dashboardCategory === 'x') {
            let containerData = {
                dimensions: detail.dimensions,
                col: detail.variableOfInterest,
                data: this.props.data,
                itemsToRankCols: detail.itemsToRankCols,
                dimensionLabels: detail.dimensionLabels,
                isMediumScreen: this.props.isMediumScreen,
                isLargeScreen: this.props.isLargeScreen,
                dashboardTitle: detail.dashboardTitle,
                overallChartTitle:  detail.overallChartTitle,
                dimensionChartsTitle:  detail.dimensionChartsTitle
            }
            
            selectedDashboard = <XDashbaordContainer  {...containerData} />  
        } else if (dashboardCategory === 'ram-metric') {
            let containerData = {
                data: this.props.data,
                metricColumns: detail.metricColumns,
                statsName: detail.statsName,
                dimensionLabels: detail.dimensionLabels,
                dimensions: detail.dimensions,
                isMediumScreen: this.props.isMediumScreen,
                isLargeScreen: this.props.isLargeScreen,
                dashboardTitle: detail.dashboardTitle,
                overallChartTitle:  detail.overallChartTitle,
                dimensionChartsTitle:  detail.dimensionChartsTitle
            }
            selectedDashboard = <MagnitudeDashboardContainer  {...containerData} />            
        } else if (dashboardCategory === 'top-n-ram') {
            let containerData = {
                data: this.props.data,
                itemsToFilterCol: detail.itemsToFilterCols[0],
                numberOfItemsToFilterFor: 10,
                dimensionLabels: detail.dimensionLabels,
                dimensions: detail.dimensions,
                isMediumScreen: this.props.isMediumScreen,
                isLargeScreen: this.props.isLargeScreen,
                dashboardTitle: detail.dashboardTitle,
                overallChartTitle:  detail.overallChartTitle,
                dimensionChartsTitle:  detail.dimensionChartsTitle
            }
            selectedDashboard = <TopNRankAndMagnitudeDashboardContainer   {...containerData} />        
        } else if (dashboardCategory === "bg-ram") {
            let containerData = {
                dimensions: detail.dimensions,
                col: detail.variableOfInterest,
                data: this.props.data,
                dimensionLabels: detail.dimensionLabels,
                isMediumScreen: this.props.isMediumScreen,
                isLargeScreen: this.props.isLargeScreen,
                dashboardTitle: detail.dashboardTitle,
                overallChartTitle:  detail.overallChartTitle,
                dimensionChartsTitle: detail.dimensionChartsTitle,
            }
            selectedDashboard = <BackgroundDashboardContainer   {...containerData} />    
        }
        return  <div  style={containerStyle}>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <meta name="description" content="data driven blog"/>
                        <title>Surveez</title>
                        <link rel="canonical" href="https://surveez.netlify.com/" />
                    </Helmet>
                  {selectedDashboard}    
                </div>           
    }
    
}

Dashboard.contextType = ThemeContext;

export default Dashboard